import { FC, useState } from "react";
import { Select } from "./Select";
import { DateRangePicker } from "../atoms/DataRangePicker";
import { t } from "i18next";
import { User } from "@/app/auth/auth";
import { FormikConfig, FormikProps } from "formik";
import { DateTime } from "luxon";

export type FiltersMaintenanceprops = {
  filtersOpen: () => void;
  personal: Array<User>;
  formik: FormikProps<any>;
};

const optionsUrgencia = [
  { id: undefined, name: "Todos" },
  { id: 3, name: "Alta" },
  { id: 2, name: "Media" },
  { id: 1, name: "Baja" },
];

const optionsState = [
  { id: undefined, name: "Todos" },
  { id: 1, name: "Completado" },
  { id: 0, name: "Pendiente" },
];

export const FiltersMaintenance: FC<FiltersMaintenanceprops> = ({
  filtersOpen,
  personal,
  formik,
}) => {
  //STATE PARA EL SELECT DE ESTADO
  const [state, setState] = useState(optionsState[0]);
  const [urgencia, setUrgencia] = useState(optionsUrgencia[0]);

  // Función para limpiar todos los filtros
  const clearFilters = () => {
    formik.resetForm();
    setState(optionsState[0]);
    setUrgencia(optionsUrgencia[0]);
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay de fondo */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={filtersOpen}
      ></div>

      {/* Modal */}
      <div className="relative bg-white w-full max-w-4xl mx-4 rounded-lg shadow-xl p-6">
        {/* Header del modal */}
        <div className="flex justify-between items-center mb-6">
          <h2 />
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 text-2xl"
            onClick={filtersOpen}
          >
            <span className="sr-only">Close</span>
            &times;
          </button>
        </div>

        {/* Contenido del formulario */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
          <div className="w-full">
            <Select
              name="state"
              selected={optionsState.find(
                (option) => option.id == formik.values.state
              )}
              setSelected={(option) => formik.setFieldValue("state", option.id)}
              options={optionsState}
              tittle={t("maintenance.views.status")}
              textDescribe=""
            />
          </div>
          <div className="w-full">
            <Select
              name="assigneId"
              selected={personal.find(
                (personal) => personal.id == formik.values.assignedId
              )}
              setSelected={(option) =>
                formik.setFieldValue("assignedId", option.id)
              }
              options={personal}
              tittle={t("maintenance.views.assigned_to")}
              textDescribe=""
            />
          </div>
          <div className="w-full">
            <Select
              name="urgency"
              selected={optionsUrgencia.find(
                (urgency) => urgency.id == formik.values.urgency
              )}
              setSelected={(option) =>
                formik.setFieldValue("urgency", option.id)
              }
              options={optionsUrgencia}
              tittle={t("maintenance.views.urgency")}
              textDescribe=""
            />
          </div>
          <div className="w-full">
            <DateRangePicker
              id="date"
              label={t("maintenance.views.inter_dates")}
              value={{
                startDate: formik.values.startDate
                  ? DateTime.fromFormat(
                      formik.values.startDate,
                      "yyyy-MM-dd"
                    ).toJSDate()
                  : new Date(),
                endDate: formik.values.endDate
                  ? DateTime.fromFormat(
                      formik.values.endDate,
                      "yyyy-MM-dd"
                    ).toJSDate()
                  : new Date(),
              }}
              onDateChange={(startDate, endDate) => {
                formik.setFieldValue(
                  "startDate",
                  DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")
                );
                formik.setFieldValue(
                  "endDate",
                  DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd")
                );
              }}
            />
          </div>
        </div>

        {/* Botones de acción */}
        <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
          <button
            type="button"
            onClick={clearFilters}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {t("general.clear")}
          </button>
          <button
            type="button"
            onClick={filtersOpen}
            className="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {t("general.close")}
          </button>
        </div>
      </div>
    </div>
  );
};
